import styled from "styled-components";

type ImageProps = {
  $img: string;
};
export const ImgContainerq = styled.div<ImageProps>`
  display: block;
  width: 648px;
  height: 486px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  background-position: center;
  background-image: center;
  @media (max-width: 430px) {
    width: 393px;
    margin: 0;
    border-radius: 0;
  }
`;
export const ImgContainer = styled.div<ImageProps>`
  margin: 0 auto;
  margin-top: 10px;
  display: flex;
  justify-content: top;
  align-items: center;
  flex-direction: column;
  width: 70%;
  height: 550px;
  width: 1300px;
  border-radius: 30px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  background-position: right;
  background-image: right;
  @media (max-width: 430px) {
    width: 393px;
    padding-right: 10px;
    margin: 0;
    border-radius: 0;
  }
`;
export const Container = styled.div`
  margin: 0 auto;
  justify-content: center;
  width: 1300px;
  display: flex;
  flex-direction: row;
  @media (max-width: 430px) {
    width: 393px;
    flex-direction: column;
    align-items: center;
  }
`;

export const OuterContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-top: 40px;
  width: 1200px;

  background-color: rgba(248, 248, 248, 1);
  border-radius: 24px;
  padding: 115px 100px 100px 115px;
  @media (max-width: 430px) {
    width: 373px;
    padding: 15px;
  }
`;
export const Programm = styled.div`
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  height: 5133px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  padding-bottom: 100px;
`;
export const EscapeBtn = styled.button`
  padding: 0;
  margin: 0;
  display: block;
  margin-top: -80px;
  margin-left: 1040px;
  background-color: transparent;
  color: black;
  width: 20px;
  height: 20px;
  cursor: pointer;
  font-size: 20px;
  font-family: Avenir Next;
  border: none;
  text-align: left;
  &:hover {
    background-color: transparent;
    color: black;
  }
  z-index: 20000;
  @media (max-width: 430px) {
    margin-top: 10px;
    margin-left: 330px;
  }
`;
export const ProrgammTitle = styled.div`
  display: block;
  margin: 0;

  font-size: 50px;
  font-family: Cormorant Infant;
  font-weight: 500;
  color: #000000;
  margin-top: 60px;
  margin-bottom: 40px;
  @media (max-width: 430px) {
    margin-top: -30px;
  }
`;
export const ProgrammCont = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
`;
export const ProgrammSectionCont = styled.div`
  margin-bottom: 14px;
`;
export const ProgrammCloseAll = styled.div`
  font-family: Avenir Next;
  font-size: 1rem;
  font-weight: 500;
  text-align: right;
  color: #55749f;
  cursor: pointer;
  @media (max-width: 430px) {
    font-size: 16px;
  }
`;
export const ProgrammTextCont = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 40px;
  @media (max-width: 430px) {
    margin-left: 20px;
  }
`;
export const ProgrammText = styled.div`
  font-family: Cormorant Infant;
  font-size: 35px;
  font-weight: 500;
  text-align: left;
  color: #141414;
  @media (max-width: 430px) {
    font-size: 20px;
  }
`;
export const Tag = styled.div`
  font-family: Avenir Next;
  font-size: 1rem;
  font-weight: 500;
  background-color: #bfdcf5;
  padding: 5px 10px;
  text-align: center;
  border-radius: 22px;
  margin-bottom: 14px;
  max-width: 90px;
`;
export const ProgrammBlock = styled.div`
  width: 100%;
  border: 1px solid black;
  border-radius: 50px;
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  padding-bottom: 20px;
  align-items: center;
  @media (max-width: 430px) {
    padding-top: 15px;
    padding-bottom: 15px;
  }
`;
export const FAQTextSmall = styled.div`
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  color: #a7a7a7;
`;
export const ProgrammBigText = styled.div`
  font-family: Avenir Next;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  margin-left: 20px;
  margin-top: 5px;
  margin-bottom: 5px;
`;
export const FAQTextSmall2 = styled.div`
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  color: #a7a7a7;

  margin-bottom: 14px;
  margin-left: 20px;
`;
export const ProgrammSpinner = styled.div<ImageProps>`
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin-right: 40px;
  -webkit-transition-duration: 0.8s;
  -moz-transition-duration: 0.8s;
  -o-transition-duration: 0.8s;
  transition-duration: 0.8s;

  -webkit-transition-property: -webkit-transform;
  -moz-transition-property: -moz-transform;
  -o-transition-property: -o-transform;
  transition-property: transform;

  overflow: hidden;
  &:active {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
  }
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  align-items: center;

  @media (max-width: 430px) {
    margin-right: 20px;
  }
`;

export const ProgrammTextDiv4Li = styled.li`
  font-family: Avenir Next;
  font-size: 1rem;
  font-weight: 400;
  text-align: left;
  color: #679d00;
  margin-left: 32px;
`;
export const ProgrammTextDiv4Li2 = styled.div`
  color: black;
`;
export const ProgrammUl = styled.ul`
  color: black;
  list-style-type: "✔";
`;

export const Btn2 = styled.button`
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  width: 265px;
  height: 50px;
  background-color: white;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }
`;
export const Container1 = styled.div`
  margin: 0 auto;
  justify-content: space-around;
  width: 1300px;
  display: flex;
  flex-direction: row;
  @media (max-width: 430px) {
    width: 383px;
    overflow-x: auto;
    justify-content: start;
    margin-left: 10px;
    margin-right: 10px;
    gap: 10px;
  }
`;
export const TextCont = styled.div`
  padding-left: 50px;
  width: 550px;
  display: flex;
  flex-direction: column;
  justify-content: top;
  gap: 40px;
  height: 400px;
  margin-top: 40px;
  @media (max-width: 430px) {
    width: 383px;
    margin: 0;
    padding: 0;
    padding-left: 5px;
    margin-bottom: 100px;
  }
`;
export const TextWrap = styled.div`
  padding: 10px;
  background-color: white;
  border-radius: 20px;
  @media (max-width: 430px) {
    width: 373px;
    margin: 0;
    padding: 10px;
    background-color: white;
    border-radius: 20px;
  }
`;

export const Text1 = styled.div`
  display: block;
  margin: 0 auto;
  font-size: 50px;
  font-family: Cormorant Infant;
  font-weight: 500;
  text-align: center;
  color: #000000;
  margin-top: 60px;
  @media (max-width: 430px) {
    font-size: 30px;
    margin: 0;
    margin-bottom: 20px;
    margin-top: 30px;
  }
`;
export const SmallText = styled.div`
  display: block;
  margin: 0 auto;
  font-size: 18px;
  font-family: Avenir Next;
  text-align: center;
  color: #141414;
  margin-bottom: -70px;
  margin-top: 40px;
  @media (max-width: 430px) {
    margin: 0;
    margin-top: 70px;
    margin-bottom: -20px;
  }
`;
export const SmallTextq = styled.div`
  display: block;
  margin: 0 auto;
  font-size: 18px;
  font-family: Avenir Next;
  text-align: center;
  color: white;
  margin-top: 80px;
`;
export const SmallText1 = styled.div`
  display: block;
  margin: 0 auto;
  font-size: 1rem;
  font-family: Avenir Next;
  text-align: center;
  color: #ffffff;
  margin-bottom: -70px;
  margin-top: 40px;
  padding-top: 40px;
  text-transform: uppercase;
`;

export const Span = styled.span`
  color: #55749f;
  font-size: 50px;
  font-family: Cormorant Infant;
  font-weight: 500;
  margin-left: 10px;
  @media (max-width: 430px) {
    width: 383px;
    font-size: 30px;
  }
`;

export const H11 = styled.div`
  font-family: Cormorant Infant;
  font-size: 100px;
  font-weight: 500;
  text-align: center;
  color: #55749f;
`;
export const H1W = styled.div`
  font-family: Cormorant Infant;
  font-size: 60px;
  padding-top: 40px;
  margin-top: 36px;
  font-weight: 500;
  text-align: center;
  color: #ffffff;
`;

export const H2W = styled.div`
  margin: 0 auto;
  margin-top: 36px;
  width: 600px;
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  @media (max-width: 430px) {
    width: 383px;
  }
`;

export const H1q = styled.div`
  font-family: Cormorant Infant;
  font-size: 60px;
  margin-top: 36px;
  font-weight: 500;
  text-align: center;
  color: white;
`;

export const H2q = styled.div`
  margin: 0 auto;
  margin-top: 36px;
  width: 600px;
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  color: white;
  @media (max-width: 430px) {
    width: 383px;
  }
`;

export const H1 = styled.div`
  font-family: Cormorant Infant;
  font-size: 60px;
  padding-top: 40px;
  margin-top: 36px;
  font-weight: 500;
  text-align: center;
  color: #141414;
  @media (max-width: 430px) {
    font-size: 50px;
  }
`;

export const H2 = styled.div`
  margin: 0 auto;
  margin-top: 36px;
  width: 600px;
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  @media (max-width: 430px) {
    font-size: 18px;
    width: 383px;
  }
`;

export const BtnW = styled.a`
  text-decoration: none;
  padding: 10px 15px;
  margin-top: 36px;
  background-color: white;
  color: black;
  border: 1px solid white;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }
`;
export const Btnq1 = styled.button`
  display: block;
  width: 230px;
  height: 50px;
  padding: 10px 15px;
  margin: 0 auto;
  margin-top: 350px;
  background-color: white;
  color: black;
  border: 1px solid white;
  cursor: pointer;
  border-radius: 30px;
  font-size: 18px;
  font-family: Avenir Next;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }
`;
export const Btnq = styled.a`
  display: block;
  margin: 0 auto;
  margin-top: 36px;
  padding: 10px 15px;
  text-decoration: none;
  background-color: white;
  color: black;
  border: 1px solid white;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }
`;
export const Btn = styled.button`
  display: block;
  margin: 0 auto;
  margin-top: 36px;
  padding: 10px 15px;
  background-color: black;
  color: white;
  border: 1px solid black;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  &:hover {
    background-color: white;
    color: black;
    transition: ease-in 0.2s;
    border: 1px solid white;
  }
`;

export const Block = styled.div`
  width: 30%;
  margin-top: 40px;
  @media (max-width: 430px) {
    width: 393px;
  }
`;
export const ImgBlock = styled.div<ImageProps>`
  width: 38px;
  display: block;
  height: 38px;
  margin: 0 auto;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  align-items: center;
  background-position: center;
`;
export const TitleBlock = styled.div`
  width: 100%;
  display: block;
  font-family: Cormorant Infant;
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  text-decoration-skip-ink: none;
  margin-top: 15px;
  margin-bottom: 15px;
`;
export const TextBlock = styled.div`
  width: 100%;
  display: block;
  font-family: Avenir Next;
  font-size: 15px;
  font-weight: 400;
  text-align: center;
  text-decoration-skip-ink: none;
`;

export const TitleBlock1 = styled.div`
  width: 100%;
  display: block;
  font-family: Cormorant Infant;
  font-size: 30px;
  font-weight: 500;
  text-align: left;
  text-decoration-skip-ink: none;
  margin-top: 15px;
  margin-bottom: 15px;
`;
export const TextBlock1 = styled.div`
  width: 100%;
  display: block;
  font-family: Avenir Next;
  font-size: 15px;
  font-weight: 400;
  text-align: left;
  text-decoration-skip-ink: none;
`;
export const Span1 = styled.div`
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  margin-right: 5px;
  color: #a7a7a7;
`;
export const Box2 = styled.div`
  width: 20%;
  padding: 20px;
  margin-top: 20px;
  border-top: 1px solid #b4b4b4;
  border-right: 1px solid #b4b4b4;
  @media (max-width: 430px) {
    border: none;
    width: 373px;
    align-items: center;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: start;
    position: relative;
    margin-left: 10px;
  }
`;
export const Box21 = styled.div`
  width: 20%;
  padding: 20px;
  margin-top: 20px;
  border-top: 1px solid #b4b4b4;
  @media (max-width: 430px) {
    border: none;
    width: 373px;
    align-items: center;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: start;
    position: relative;
    margin-left: 10px;
  }
`;
export const Box = styled.div`
  width: 25%;
  padding: 20px;
  margin-top: 20px;
  border-top: 1px solid #b4b4b4;
  border-right: 1px solid #b4b4b4;
  @media (max-width: 430px) {
    border: none;
    width: 373px;
    align-items: center;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: start;
    position: relative;
    margin-left: 10px;
  }
`;
export const Qwerty = styled.div`
  margin-top: -50px;
`;
export const Box1 = styled.div`
  width: 25%;
  padding: 20px;
  margin-top: 20px;
  border-top: 1px solid #b4b4b4;
  @media (max-width: 430px) {
    border: none;
    width: 373px;
    align-items: center;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: start;
    position: relative;
    margin-left: 10px;
  }
`;
export const CircleContainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 430px) {
    margin-bottom: 60px;
  }
`;
export const Circle1 = styled.div`
  background-color: #c7e8e8;
  height: 10px;
  width: 10px;
  border-radius: 8px;
`;
export const FAQCircle = styled.div`
  background-color: #55749f;
  height: 10px;
  width: 10px;
  border-radius: 10px;
`;
export const CircleText1 = styled.div`
  color: black;
  display: block;
  font-family: Avenir Next;
  font-size: 1rem;
  font-weight: 400;
  text-align: left;
  text-transform: uppercase;
  margin-left: 8px;
`;
export const BoxTitleN = styled.div`
  font-family: Cormorant Infant;
  font-size: 40px;
  font-weight: 500;
  line-height: 34.4px;
  text-align: left;
  margin-top: 18px;
  @media (max-width: 430px) {
    margin: 0;
    font-size: 30px;
    margin-bottom: 60px;
    margin-left: 10px;
  }
`;
export const BoxTitleB = styled.div`
  font-family: Cormorant Infant;
  font-size: 40px;
  font-weight: 500;
  line-height: 34.4px;
  text-align: left;
  color: #55749f;
  @media (max-width: 430px) {
    margin: 0;
    font-size: 30px;
    margin-bottom: 60px;
    margin-left: 10px;
  }
`;
export const BoxText = styled.div`
  margin-top: 16px;
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  text-decoration-skip-ink: none;
  @media (max-width: 430px) {
    text-align: start;
    position: absolute;
    top: 20px;
  }
`;

export const FAQCont2 = styled.div`
  width: 900px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 14px;
  margin-bottom: 40px;
  @media (max-width: 430px) {
    width: 393px;
    gap: 10px;
    margin-top: 10px;
    margin-left: 10px;
  }
`;
export const FAQuestion = styled.div`
  width: 750px;
  border: 1px solid black;
  border-radius: 50px;
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0px 60px;
  justify-content: space-between;
  @media (max-width: 430px) {
    width: 383px;
    padding: 0 20px;
    height: 60px;
  }
`;
export const InnerText = styled.div`
  display: none;
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  background-color: #ffffff;
  width: 100%;
  padding: 20px;
  border-radius: 20px;
  margin-top: 10px;
  @media (max-width: 430px) {
    width: 363px;
  }
`;
export const Spinner = styled.div<ImageProps>`
  width: 16px;
  height: 16px;
  cursor: pointer;
  -webkit-transition-duration: 0.8s;
  -moz-transition-duration: 0.8s;
  -o-transition-duration: 0.8s;
  transition-duration: 0.8s;

  -webkit-transition-property: -webkit-transform;
  -moz-transition-property: -moz-transform;
  -o-transition-property: -o-transform;
  transition-property: transform;

  overflow: hidden;
  &:active {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
  }
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  align-items: center;
`;
export const FAQ1 = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
